'use strict';

(function() {
    $(document).ready(function() {
        var $filterTrigger = $('.js-filter-close-btn');

        if($filterTrigger.length > 0) {
            $filterTrigger.click(function() {
                //Remove filter from dom
                $(this).parent('.filter-tag').remove();

                //Call search again to modify results
            });
        }
    });
})();